import { getEquivalentParameterLookupNames } from './availableProjectParameterCache';

export function createParameterNameMap(
  parameterNames: string[],
): Map<string, string> {
  const names = new Map<string, string>();
  parameterNames.forEach((name) => {
    const trimmed = name?.trim();
    if (!trimmed) return;
    names.set(trimmed.toLowerCase(), trimmed);
  });
  return names;
}

export function createEquivalentParameterNameMap(
  parameterNames: string[],
): Map<string, string> {
  const names = new Map<string, string>();
  parameterNames.forEach((name) => {
    const trimmed = name?.trim();
    if (!trimmed) return;
    getEquivalentParameterLookupNames(trimmed).forEach((lookupName) => {
      names.set(lookupName, trimmed);
    });
  });
  return names;
}

export function hasAvailableEquivalentParameter(
  availableParameters: Map<string, string>,
  parameterName: string,
): boolean {
  return getEquivalentParameterLookupNames(parameterName).some((lookupName) => availableParameters.has(lookupName));
}

export function getMissingParameterNames(
  requestedParameters: string[],
  availableParameters: string[],
): string[] {
  const requested = createParameterNameMap(requestedParameters);
  const available = createEquivalentParameterNameMap(availableParameters);

  return Array.from(requested.entries())
    .filter(([, originalName]) => !hasAvailableEquivalentParameter(available, originalName))
    .map(([, originalName]) => originalName);
}

export function areProjectParametersAvailable(
  requestedParameters: string[],
  availableParameters: string[],
): boolean {
  return getMissingParameterNames(requestedParameters, availableParameters)
    .length === 0;
}
